import { render } from "./documents_slider.vue?vue&type=template&id=306f27dd"
import script from "./documents_slider.vue?vue&type=script&lang=js"
export * from "./documents_slider.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__